export default function GetMainPurchasePlanIdFromRFPId($log, $http, $q) {
  'ngInject';

  return function (rfpId) {
    console.warn(
      'The getMainPurchasePlanIdFromRFPId service has been deprecated and will be removed from a future release.'
    );

    return $http.get(
      '/aptitude/buyer/GroupImpactServiceController/topLevelPurchasePlanIdByRfpId/' +
        rfpId,
      { intercept: true, cache: true }
    );
  };
}
